var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E4E4E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 13.1991C5.5 11.2094 5.62248 10.4323 5.95502 9.87604C6.12173 9.59717 6.35746 9.34813 6.72781 9.02042C6.88751 8.87911 7.06528 8.72904 7.26892 8.55715C7.30147 8.52967 7.33468 8.50164 7.36859 8.47299C7.60924 8.26966 7.87977 8.03971 8.18107 7.77216C8.37357 7.6232 8.57192 7.46126 8.77757 7.29337C9.17666 6.96754 9.60322 6.61929 10.0678 6.30002C10.7768 5.81272 11.4331 5.5 11.9796 5.5C12.5275 5.5 13.1926 5.81247 13.9112 6.29907C14.3972 6.62817 14.8488 6.99336 15.2667 7.3312C15.4581 7.48595 15.6424 7.63497 15.8196 7.77214C16.1209 8.0397 16.3915 8.26965 16.6321 8.47298C16.6658 8.50143 16.6988 8.52929 16.7311 8.55659C16.935 8.72871 17.1129 8.87894 17.2728 9.02039C17.643 9.34808 17.8787 9.59711 18.0453 9.87595C18.3777 10.4322 18.5 11.2093 18.5 13.1991C18.5 14.6383 18.4102 15.672 18.2069 16.4219C18.0077 17.1568 17.7092 17.5849 17.3051 17.863C16.8827 18.1537 16.2832 18.3239 15.3942 18.4118C14.5069 18.4995 13.4015 18.5 12 18.5C10.5985 18.5 9.49306 18.4995 8.60579 18.4118C7.71685 18.3239 7.11732 18.1537 6.69487 17.863C6.29076 17.5849 5.99235 17.1568 5.79313 16.4219C5.58984 15.672 5.5 14.6383 5.5 13.1991Z",
    stroke: "#1B1625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87695 14.8948H14.1232",
    stroke: "#1B1625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.0aed5d6e69542158d223feb44fb5b5fe.svg";
export { ForwardRef as ReactComponent };